import { render, staticRenderFns } from "./lackWarning.vue?vue&type=template&id=3de64326"
import script from "./lackWarning.vue?vue&type=script&lang=js"
export * from "./lackWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports